import jsLogger, { ILogger } from 'js-logger';

export default() => {
    jsLogger.useDefaults();
    return jsLogger.get("logger");
}